import { ROUTING_PATH } from '@shared/constants/routingPath';
import { FeatureFlagTabs } from '@shared/guards/basic-redirect-to-next-tab.guard';

export const FORECAST_ROUTES_FEATURE_FLAGS: FeatureFlagTabs = {
  [`${ROUTING_PATH.FORECAST_ROUTING.DRIVERS.INDEX}/${ROUTING_PATH.FORECAST_ROUTING.DRIVERS.CUSTOM_DRIVERS}`]:
    'custom_drivers',
  [`${ROUTING_PATH.FORECAST_ROUTING.DRIVERS.INDEX}/${ROUTING_PATH.FORECAST_ROUTING.DRIVERS.PATIENT_DRIVER.INDEX}`]:
    'tab_forecast_drivers',
  [`${ROUTING_PATH.FORECAST_ROUTING.DRIVERS.INDEX}/${ROUTING_PATH.FORECAST_ROUTING.DRIVERS.SITE_DRIVER.INDEX}`]:
    'tab_forecast_drivers',
  [ROUTING_PATH.FORECAST_ROUTING.FORECAST_METHODOLOGY]: 'forecast_methodology_tab',
  [ROUTING_PATH.FORECAST_ROUTING.TIMELINE]: null,
};
